import * as types from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
};

const promotionRequests = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_PROMOTION_REQUESTS_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };

    default:
      return state;
  }
};

export default promotionRequests;
